<template>
    <div class="relative size-full overflow-y-auto overflow-x-hidden p-6 md:h-auto md:max-h-[calc(100vh-20rem)] md:p-8">
        <Transition :name="productForm().extraDetailsInfo ? 'fade-left' : 'fade-right'" mode="out-in">
            <template v-if="!Object.keys(productForm().extraDetailsInfo).length">
                <ModalProductExtras v-bind="props" />
            </template>
            <template v-else>
                <ModalProductExtraDetailsInfo v-bind="props" />
            </template>
        </Transition>
    </div>
</template>

<script setup lang="ts">
    import type { ProductOrderBuddy } from '~/types/orderbuddy-types'
    import ModalProductExtraDetailsInfo from '~/components/Modal/ModalProduct/ModalProductExtraDetailsInfo.vue'
    import ModalProductExtras from '~/components/Modal/ModalProduct/ModalProductExtras.vue'
    import { productForm } from '~/store/productForm'
    const props = defineProps<ProductOrderBuddy>()
</script>
